import React from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import LogoImg from "../../assets/images/logo.svg";
import { changeSearch } from "../../features/filter/filterSlice";

const Navbar = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const debounce = (fn, delay) => {
    let timeoutId;

    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  };

  const doSearch = (event) => {
    const text = event.target.value;
    dispatch(changeSearch(text));
  };

  const searchHandler = debounce(doSearch, 500);
  return (
    <nav className="container relative py-3">
      <div className="flex items-center justify-between">
        <Link to="/">
          <img src={LogoImg} alt="Logo" />
        </Link>
        <div className="flex-1 max-w-xs search-field group">
          <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
          <input
            type="text"
            placeholder="Search Task"
            className="search-input"
            id="lws-searchTask"
            onChange={searchHandler}
            style={{ color: "black" }}
            disabled={pathname !== "/task"}
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
